'use client';
import React, { ReactNode, useState } from 'react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

interface FAQAccordionBlockProps {
	question: string;
	answer: string;
}

export default function FAQAccordionBlock({ question, answer }: FAQAccordionBlockProps): ReactNode {
	const [isOpen, setIsOpen] = useState(false);

	function toggleAccordion() {
		setIsOpen(!isOpen);
	}

	return (
		<div className="border-b border-gray-200 px-4">
			<button className="flex w-full items-center justify-between py-3" onClick={toggleAccordion} type="button">
				<h2 className="text-pretty w-5/6 whitespace-pre-wrap text-left text-lg font-semibold">{question}</h2>
				<ChevronDownIcon
					aria-hidden="true"
					className={`h-6 w-6 transform transition-transform ${isOpen ? 'rotate-180' : ''}`}
				/>
			</button>
			<div
				className={`transition-max-height overflow-hidden duration-700 ease-in-out ${isOpen ? 'max-h-96' : 'max-h-0'}`}
			>
				<p className="py-2">{answer}</p>
			</div>
		</div>
	);
}
